import { IsInt, IsString } from 'class-validator';

export class PersonalInformationInquiryDto {
  @IsString()
  nationalId!: string;

  @IsInt()
  birthDate!: number;
}
